<template>
  <IQOS
    :title="$t('online_payment.api_keys.title')"
    :readonly="false"
    class="iqos-empty"
  >
    <div @click="connectStripe" v-if="!merchant.stripe_account">
      <img
        class="stripe-connect-button"
        src="/icons/stripe-connect.png"
        alt=""
      />
    </div>
    <div v-else>
      <p class="comment c-green pt-0">
        {{ $t("settings_cafe.liqpay.stripe_active") }}
      </p>
      <DashboardButton class="iqos-group-item" @click="openStripeDashboard">
        {{ $t("settings_cafe.liqpay.stripe_open_btn") }}
      </DashboardButton>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import DashboardButton from "@/components/DashboardButton.vue";

import StripeAPI from "@/api/stripe";

export default {
  props: {
    merchant: Object,
  },
  methods: {
    connectStripe() {
      StripeAPI.connect(this.merchant._id)
        .then((ok) => {
          this.$store.dispatch("fetchCafe");
        })
        .catch((error) => {
          alert(`Stripe error :(`);
        });
    },
    openStripeDashboard() {
      StripeAPI.getOnboardingLink(this.merchant._id)
        .then((data) => {
          if (data.url) window.location.href = data.url;
        })
        .catch((error) => {
          consol.error(error);
        });
    },
  },
  mounted() {},
  computed: {
      cafe() {
          return this.$store.state.cafe;
      }
  },
  components: {
    IQOS,
    DashboardButton,
  },
};
</script>

<style scoped>
.stripe-connect-button {
    width: 30vh;
    cursor: pointer;
}
</style>